<!--  DEALER HEADER  -->

<ui-dealer-header [location]="'engage_authenticate'"></ui-dealer-header>

<!--  END DEALER HEADER  -->

<!--  HEADING  -->

<div class="heading">
	<h3>You're safe to leave!</h3>
	<p>
		We have successfully forgotten your personal details on this device. In order to access your customised deal
		again, we will need to verify you by sending you an access code to your email address or mobile.
	</p>
</div>

<!--  END HEADING  -->
